/**
 * Turn the Cognito ids the audit log and consent records store into the
 * member's email.
 *
 * Those records name the actor by `sub`, a UUID nobody can read. The team list
 * carries each member's sub and email, but only for a role that can manage the
 * team; anyone else, or a member since removed, keeps seeing the raw id rather
 * than a guess.
 */
import { useAsync } from "./useAsync.js";
import { api } from "./api.js";

export function usePeople(org: string): (id: string | undefined) => string | undefined {
  const team = useAsync(() => api.team(org).catch(() => []), [org]);
  const byId = new Map<string, string>();
  for (const m of team.data ?? []) {
    if (!m.email) continue;
    byId.set(m.username, m.email);
    if (m.sub) byId.set(m.sub, m.email);
  }
  return (id) => (id ? byId.get(id) ?? id : id);
}
